import Typography from '@mui/material/Typography'
import Card from '@mui/material/Card'
import { Box, Button, Divider } from '@mui/material'

import { useEffect } from 'react'
import dayjs from 'dayjs'
import axios, { pluckData } from 'src/utilities/http-client'
import { useAppDispatch, useAppSelector } from 'src/store/hooks'
import { downloadFile } from 'src/v3/utilities/filesystem'
import {
  errorMessageChanged,
  fetchExports,
  fetchOutstandingExports,
  selectExports,
  selectExportsStatus,
  selectOutstandingExports,
  selectOutstandingExportsStatus,
} from '../../admin.slice'

let getPriorExport = (timestamp: string) =>
  axios
    .get<unknown>(
      `/api/v2/admin/accreditations/prior-export?exportTimestamp=${timestamp}`,
    )
    .then(pluckData)

export default () => {
  let dispatch = useAppDispatch()

  let exports = useAppSelector(selectExports)
  let exportsStatus = useAppSelector(selectExportsStatus)
  let outstandingExports = useAppSelector(selectOutstandingExports)
  let outstandingExportsStatus = useAppSelector(selectOutstandingExportsStatus)

  useEffect(() => {
    if (exportsStatus === 'uninitialized') {
      dispatch(fetchExports())
    }
  }, [exportsStatus])

  useEffect(() => {
    if (outstandingExportsStatus === 'uninitialized') {
      dispatch(fetchOutstandingExports())
    }
  }, [outstandingExportsStatus])

  return (
    <Card sx={{ p: 2 }}>
      <Typography
        variant="h6"
        sx={{ fontFamily: 'revert', textAlign: 'center' }}
      >
        Export New Jersey Submissions
      </Typography>
      <Divider sx={{ my: 1 }} />
      <Typography>
        Unexported New Jersey Rows: {outstandingExports.length}
      </Typography>
      <div className="flex justify-center mt-2">
        <Button
          variant="outlined"
          disabled={!outstandingExports.length}
          onClick={() => {
            axios
              .post('/api/v2/admin/accreditations/create-export')
              .then(pluckData)
              .then((response: any) =>
                downloadFile(response, 'new_jersey_submission.csv'),
              )
              .then(() => dispatch(fetchExports()))
              .then(() => dispatch(fetchOutstandingExports()))
              .catch((err) =>
                dispatch(
                  errorMessageChanged(
                    `CSV Export Failed: ${err.response?.data || err}`,
                  ),
                ),
              )
          }}
        >
          Export Rows
        </Button>
      </div>
      <Divider sx={{ my: 1 }} />
      <Typography sx={{ mt: 0, textAlign: 'center' }}>
        Existing Exports:
      </Typography>
      <Box sx={{ maxHeight: 400, overflow: 'scroll' }}>
        {!exports.length ? (
          <Typography
            variant="subtitle2"
            sx={{ textAlign: 'center' }}
            color="text.secondary"
          >
            No existing exports
          </Typography>
        ) : (
          exports.map((ex, i) => (
            <Box
              key={i}
              sx={{
                display: 'flex',
                flexWrap: 'wrap',
                columnGap: 1,
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <Typography>
                {dayjs(ex.timestamp, 'ms').format('MM/DD/YYYY')}
              </Typography>
              <Button
                variant="text"
                onClick={() => {
                  getPriorExport(ex.timestamp)
                    .then((response: any) =>
                      downloadFile(
                        response,
                        `new_jersey_submission_${ex.timestamp}.csv`,
                      ),
                    )
                    .catch((err) =>
                      dispatch(
                        errorMessageChanged(
                          `CSV Export Failed: ${err.response?.data || err}`,
                        ),
                      ),
                    )
                }}
              >
                Download CSV
              </Button>
            </Box>
          ))
        )}
      </Box>
    </Card>
  )
}
